




























































































import {Component, Watch, Mixins} from 'vue-property-decorator'
import {Action, Getter} from 'vuex-class'
import {$, IResource, pushByName} from 'simpli-web-sdk'
import {AppConfig} from '@/config/app.config'
import {MixinFilter} from '@/components/mixins/MixinFilter'
import {DeliveryRegisterState} from '@/enums/DeliveryRegisterState'
import {DeliveryStatus} from '@/enums/DeliveryStatus'
import {Role} from '@/enums/Role'
import FilterDelivery from '@/components/filters/FilterDelivery.vue'
import ModalDeliveryRegister from '@/components/modals/ModalDeliveryRegister.vue'
import DeliveryRequest from '@/model/request/DeliveryRequest'
import CargaCollection from '@/model/collection/CargaCollection'
import FilterToggle from '@/components/FilterToggle.vue'
import {UploadConfig} from '@/config/upload.config'
import UploadDados from '@/model/resource/UploadDados'
import {ScreenUpload} from '@/enums/ScreenUpload'
import UploadStatusButton from '@/components/UploadStatusButton.vue'
import {StatusUpload} from '@/enums/StatusUpload'

const metaInfo = () => ({
  title: $.t('view.manage.deliveryRegister.title'),
})

@Component({
  metaInfo,
  components: {UploadStatusButton, FilterToggle, FilterDelivery, ModalDeliveryRegister},
})
export default class ManageDeliveryRegisterView extends Mixins(MixinFilter) {
  @Getter('auth/role') role!: Role
  @Action('refreshView') refreshView!: Function

  AppConfig = AppConfig
  Role = Role
  pushByName = pushByName

  UploadConfig = UploadConfig

  filter = new DeliveryRequest()
  collection = new CargaCollection(this.filter)

  lastUpload: UploadDados | null = null
  ScreenUpload = ScreenUpload

  openExpectedDate() {
    this.$modal.open('deliveryRegister', DeliveryRegisterState.EXPECTED_DATE)
  }

  openOrderNumber() {
    this.$modal.open('deliveryRegister', DeliveryRegisterState.ORDER_NUMBER)
  }

  openIssueDate() {
    this.$modal.open('deliveryRegister', DeliveryRegisterState.ISSUE_DATE)
  }

  openMultipleWithDanfe() {
    this.$modal.open('deliveryRegister', DeliveryRegisterState.MULTIPLE_WITH_DANFE)
  }

  openMultipleWithoutDanfe() {
    this.$modal.open('deliveryRegister', DeliveryRegisterState.MULTIPLE_WITHOUT_DANFE)
  }

  openMultipleWithNotfis() {
    this.$modal.open('deliveryRegister', DeliveryRegisterState.MULTIPLE_WITH_NOTFIS)
  }

  openMultipleWithCTE() {
    this.$modal.open('deliveryRegister', DeliveryRegisterState.MULTIPLE_WITH_CTE)
  }

  openMultipleWithCTEReadNf() {
    this.$modal.open('deliveryRegister', DeliveryRegisterState.MULTIPLE_WITH_CTE_READ_NF)
  }

  async created() {
    if (this.$route.query.start === undefined) {
      this.filter.startDate = DeliveryRequest.defaultStartOfDay()
    }

    const upload = await UploadDados.getLastUpload(ScreenUpload.CADASTRO_CARGA)
    this.lastUpload = upload.data

    this.filter.status = `${DeliveryStatus.PENDING}`
    this.filter.event = null

    this.collection.orderBy = 'dataFinalizacao'
    this.collection.asc = false
  }

  get isLastUploadPending() {
    if (this.lastUpload) {
      return this.lastUpload.idStatusUploadFk === StatusUpload.AGUARDANDO_PROCESSAMENTO ||
          this.lastUpload.idStatusUploadFk === StatusUpload.PROCESSANDO
    }
  }

  refresh() {
    this.refreshView()
  }
}
